(function () {
  function init() {
    var buttons = document.querySelectorAll('[data-veizu-cart-clear]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (event) {
        var btn = event.currentTarget;
        if (!window.confirm('Möchtest du wirklich den ganzen Warenkorb leeren?')) return;
        btn.disabled = true;
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        })
          .then(function () {
            window.location.reload();
          })
          .catch(function () {
            btn.disabled = false;
          });
      });
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
